// import imageCompression from "browser-image-compression";

import imageCompression from "browser-image-compression";

function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

async function handleImageUpload(imageFile: any) {
  // const imageFile = event.target.files[0];
  // console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
  //console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  const options = {
    maxSizeMB: 4,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(imageFile, options);
    //console.log("compressedFile instanceof Blob", compressedFile instanceof Blob); // true
    //console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    // return compressedFile instanceof Blob ? compressedFile : imageFile; // write your own logic
    return compressedFile; // write your own logic
  } catch (error) {
    //console.log("COPMPERR : ", error);
    return imageFile;
  }
}
export const uploadImage = async (imageBase64: any) => {
  const compressedImage: any = await getBase64(await handleImageUpload(imageBase64));
  const data = new FormData();
  data.append("file", compressedImage);
  data.append("upload_preset", "hv9hftfo");
  data.append("multiple", "true");

  const res = await fetch("https://api.cloudinary.com/v1_1/drsbyonzv/upload", {
    method: "POST",
    body: data,
  });
  const file = await res.json();
  // console.log("uploadImage -> file", file);
  const image = {
    data: {
      original: file.secure_url,

      cloudId: file.public_id,
    },
  };
  return image;
};

export const uploadVideo = async (video: any) => {
  //TODO: need edit for future usage
  // console.log("videovideo", { video })

  try {
    // let reader = new FileReader();
    // reader.readAsText(video);

    const data = new FormData();
    data.append("file", video);
    data.append("upload_preset", "grblirlf");
    data.append("multiple", "true");
    // console.log("dataaaa", { data })

    const res = await fetch("https://api.cloudinary.com/v1_1/dtkb6bsxf/video/upload", {
      method: "POST",
      body: data,
    });
    // console.log("resres", { res })
    const file = await res.json();
    // console.log("uploadImage -> file", file);
    const image = {
      data: {
        original: file.secure_url,
        cloudId: file.public_id,
      },
    };
    return image;
  } catch (error) {
    // console.log("ERRRR", error.message)
  }
};

export const uploadGallery = async (gallery: any) => {
  const arrayOfImageBase64 = (
    await Promise.allSettled(
      gallery.map(async (img: any) => await getBase64(await handleImageUpload(img.originFileObj)))
    )
  )
    //@ts-ignore
    .map((final) => final?.value);

  // res_promises will be an array of promises
  let res_promises = arrayOfImageBase64.map(
    (file) =>
      // eslint-disable-next-line no-async-promise-executor
      new Promise(async (resolve, reject) => {
        let data = new FormData();
        data.append("file", `${file}`);

        data.append("upload_preset", "grblirlf");
        try {
          const res = await fetch("https://api.cloudinary.com/v1_1/dtkb6bsxf/image/upload", {
            method: "POST",
            body: data,
          });
          const file = await res.json();
          // console.log("uploadGallery -> file", file);
          const image = {
            original: file.secure_url,
            cloudId: file.public_id,
          };
          resolve(image);
        } catch (error) {
          // console.log("error: ", error);
          if (error) reject(error);
        }
      })
  );
  // Promise.all will fire when all promises are resolved
  return Promise.all(res_promises);
};
